// ============================================
// common.js - 共通JavaScript
// ============================================

$(function () {

  // ===== ハンバーガーメニュー =====
  $('#hamburgerBtn').on('click', function () {
    $('#drawer').addClass('l-drawer--open');
    $('body').css('overflow', 'hidden');
  });

  $('#drawerClose').on('click', function () {
    $('#drawer').removeClass('l-drawer--open');
    setTimeout(function () {
      $('body').css('overflow', '');
    }, 300);
  });

  // ドロワーリンククリックで閉じる
  $('#drawer .l-drawer__nav-link').on('click', function () {
    $('#drawer').removeClass('l-drawer--open');
    setTimeout(function () {
      $('body').css('overflow', '');
    }, 300);
  });

  // ===== タブ切り替え =====
  $('.c-news-tab').on('click', function () {
    var $btn = $(this);
    var tabName = $btn.data('tab');
    var $tabGroup = $btn.closest('.c-news-tabs');

    $tabGroup.find('.c-news-tab').removeClass('c-news-tab--active').addClass('c-news-tab--inactive');
    $btn.removeClass('c-news-tab--inactive').addClass('c-news-tab--active');
    $tabGroup.find('.c-news-tab').attr('aria-selected', 'false');
    $btn.attr('aria-selected', 'true');

    var $panel = $('#tab-' + tabName);
    $panel.siblings('.u-tab-content').removeClass('u-tab-content--active');
    $panel.addClass('u-tab-content--active');
  });

  // ===== アコーディオン =====
  $('.c-accordion__btn').on('click', function () {
    var $btn = $(this);
    var $body = $btn.next('.c-accordion__body');
    var isOpen = $btn.hasClass('c-accordion__btn--open');

    $btn.toggleClass('c-accordion__btn--open', !isOpen);
    $body.toggleClass('c-accordion__body--open', !isOpen);
    $btn.attr('aria-expanded', !isOpen);
  });

  // 同意ラジオ変更時のメッセージ制御
  $('input[name="agree"]').on('change', function () {
    var val = $(this).val();
    if (val === 'yes') {
      $('#agreeError').hide();
    } else if (val === 'no') {
      $('#agreeError')
        .text('個人情報の取扱いに同意いただけない場合は、お問い合わせいただけません。')
        .show();
    }
  });

  // ===== 郵便番号自動補完 =====
  $('#zip').on('blur', function () {
    var zip = $(this).val().replace(/[^\d]/g, '');
    if (zip.length !== 7) return;

    $.ajax({
      url: 'https://zipcloud.ibsnet.co.jp/api/search',
      type: 'GET',
      dataType: 'jsonp',
      data: { zipcode: zip },
      success: function (data) {
        if (data.status === 200 && data.results) {
          var r = data.results[0];
          $('#address').val(r.address1 + r.address2 + r.address3);
        } else {
          alert('郵便番号が見つかりませんでした。');
        }
      },
      error: function () {
        alert('住所の取得に失敗しました。手動で入力してください。');
      }
    });
  });

  // ===== 記事本文テーブルの横スクロール対応 =====
  $('.p-entry__body table, .c-accordion__answer table').each(function () {
    $(this).wrap('<div class="table-scroll-wrapper"></div>');
    var $wrapper = $(this).parent('.table-scroll-wrapper');
    var $hint = $('<p class="table-scroll-hint">← 横にスクロールできます →</p>');
    $wrapper.before($hint);

    // スクロールが発生しているか判定して補足文を出し分け
    function checkScroll() {
      var el = $wrapper[0];
      if (el.scrollWidth > el.clientWidth) {
        $hint.addClass('is-visible');
      } else {
        $hint.removeClass('is-visible');
      }
    }

    checkScroll();
    $(window).on('resize.tableScroll', checkScroll);

    // アコーディオンを開いた時にも判定（閉じた状態ではサイズが取れないため）
    $wrapper.closest('.c-accordion__item').find('.c-accordion__btn').on('click', function () {
      setTimeout(checkScroll, 50);
    });
  });

  // ===== ページトップボタン =====
  var $pageTop = $('#pageTop');
  if ($pageTop.length) {
    $(window).on('scroll.pagetop', function () {
      if ($(this).scrollTop() > 300) {
        $pageTop.addClass('is-visible');
      } else {
        $pageTop.removeClass('is-visible');
      }
    });

    $pageTop.on('click', function () {
      $('html, body').animate({ scrollTop: 0 }, 50);
    });
  }

  // ===== サイドナビ スクロールスパイ =====
  if ($('.p-sidenav').length) {
    var $navLinks = $('.p-sidenav__link');
    var $sections = [];

    // 対応するセクション要素を収集
    $navLinks.each(function () {
      var href = $(this).attr('href');
      if (href && href.charAt(0) === '#') {
        var $target = $(href);
        if ($target.length) {
          $sections.push({ $el: $target, $link: $(this) });
        }
      }
    });

    var OFFSET = 160; // ヘッダー + グローバルナビ分

    function updateActiveNav() {
      var scrollTop = $(window).scrollTop() + OFFSET + 10;
      var currentIndex = 0;

      // ページ最下部に達したら最後の項目を強制アクティブ
      var scrollBottom = $(window).scrollTop() + $(window).height();
      var pageHeight = $(document).height();
      if (scrollBottom >= pageHeight - 2) {
        currentIndex = $sections.length - 1;
      } else {
        for (var i = 0; i < $sections.length; i++) {
          if ($sections[i].$el.offset().top <= scrollTop) {
            currentIndex = i;
          }
        }
      }

      $navLinks.closest('.p-sidenav__item').removeClass('is-active');
      if ($sections[currentIndex]) {
        $sections[currentIndex].$link.closest('.p-sidenav__item').addClass('is-active');
      }
    }

    $(window).on('scroll.sidenav', updateActiveNav);
    updateActiveNav();

    // アンカークリック時のスムーススクロール（オフセット補正付き）
    $navLinks.on('click', function (e) {
      var href = $(this).attr('href');
      if (href && href.charAt(0) === '#') {
        var $target = $(href);
        if ($target.length) {
          e.preventDefault();
          var targetTop = $target.offset().top - OFFSET + 10;
          $('html, body').animate({ scrollTop: targetTop }, 50);
        }
      }
    });
  }


  if ($('#contactForm').length) {
    var RECAPTCHA_SITE_KEY = '6Leuw1clAAAAAGtgAVYo9m5afymiMnPrvvY4JdLI';

    // jQuery Validation Plugin 日本語メッセージ設定
    $.extend($.validator.messages, {
      required:  '入力してください',
      email:     '正しいメールアドレスを入力してください',
      digits:    '半角数字で入力してください',
      minlength: $.validator.format('{0}文字以上で入力してください')
    });

    var validator = $('#contactForm').validate({
      rules: {
        company:    { required: true },
        department: { required: true },
        sei:        { required: true },
        mei:        { required: true },
        sei_kana:   { required: true },
        mei_kana:   { required: true },
        zip:        { required: true, minlength: 7 },
        address:    { required: true },
        tel:        { required: true, digits: false, pattern: /^[\d\-\(\)]+$/ },
        email:      { required: true, email: true },
        employees:  { required: true, digits: true },
        agree:      { required: true }
      },
      messages: {
        zip:      { required: '入力してください', minlength: '郵便番号は7桁で入力してください' },
        tel:      { required: '入力してください' },
        sei_kana: { required: '入力してください' },
        mei_kana: { required: '入力してください' },
        agree:    { required: '個人情報の取扱いについて、いずれかを選択してください。' }
      },
      errorElement: 'span',
      errorClass: 'c-form__error-msg',
      highlight: function (el) {
        $(el).addClass('c-input--error');
      },
      unhighlight: function (el) {
        $(el).removeClass('c-input--error');
      },
      success: function (label, el) {
        // 同意ラジオのOK時は#agreeErrorを非表示
        if ($(el).attr('name') === 'agree') {
          $('#agreeError').hide();
        }
        // エラーラベル自体を削除（※メッセージが残らないように）
        label.remove();
      },
      errorPlacement: function (error, element) {
        // 同意ラジオのエラーは#agreeErrorに表示
        if (element.attr('name') === 'agree') {
          $('#agreeError').text(error.text()).show();
          return;
        }
        // 姓名・フリガナは name-col の中に配置
        var $col = element.closest('.c-form__name-col');
        if ($col.length) {
          $col.append(error);
        } else {
          element.closest('.c-form__field').append(error);
        }
      },
      submitHandler: function (form) {
        // 同意チェック
        var agree = $('input[name="agree"]:checked').val();
        if (!agree) {
          $('#agreeError')
            .text('個人情報の取扱いについて、いずれかを選択してください。')
            .show();
          $('html, body').animate({ scrollTop: $('#agreeError').offset().top - 80 }, 300);
          return false;
        }
        if (agree === 'no') {
          $('#agreeError')
            .text('個人情報の取扱いに同意いただけない場合は、お問い合わせいただけません。')
            .show();
          $('html, body').animate({ scrollTop: $('#agreeError').offset().top - 80 }, 300);
          return false;
        }
        $('#agreeError').hide();

        // reCAPTCHA v3 トークン取得 → hidden inputに上書き → POST
        grecaptcha.ready(function () {
          grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: 'contact' }).then(function (token) {
            $('#recaptchaToken').val(token);
            form.submit();
          });
        });
      }
    });
  }

});
